import Papa from 'papaparse';
import { toPng } from 'html-to-image';

const normalizeCell = (value) => {
  if (value === null || value === undefined) return '';
  return String(value);
};

const sanitizeFilename = (value) => {
  const cleaned = String(value || 'table')
    .trim()
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '');

  return cleaned || 'table';
};

export const buildExportMatrix = (columns = [], rows = []) => {
  const headers = columns.map((column) => column.header);
  const body = rows.map((row) => columns.map((column) => normalizeCell(column.value(row))));

  return { headers, body };
};

const triggerDownload = (href, filename) => {
  const link = document.createElement('a');
  link.href = href;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  link.remove();
};

export const downloadCsv = ({ columns, rows, filename = 'table' }) => {
  const { headers, body } = buildExportMatrix(columns, rows);
  const csv = Papa.unparse({ fields: headers, data: body });
  const blob = new Blob([`\uFEFF${csv}`], { type: 'text/csv;charset=utf-8;' });
  const url = URL.createObjectURL(blob);

  triggerDownload(url, `${sanitizeFilename(filename)}.csv`);
  window.setTimeout(() => URL.revokeObjectURL(url), 0);
};

const escapeTsvCell = (value) => String(value).replace(/\t/g, ' ').replace(/\r?\n/g, ' ');

export const copyTable = async ({ columns, rows }) => {
  const { headers, body } = buildExportMatrix(columns, rows);
  const tsv = [headers, ...body]
    .map((line) => line.map(escapeTsvCell).join('\t'))
    .join('\n');

  await navigator.clipboard.writeText(tsv);
};

export const downloadTableImage = async (element, filename = 'table') => {
  if (!element) {
    throw new Error('Table element is not available');
  }

  const dataUrl = await toPng(element, {
    backgroundColor: '#ffffff',
    pixelRatio: 2,
    cacheBust: true,
  });

  triggerDownload(dataUrl, `${sanitizeFilename(filename)}.png`);
};
